module.exports = __webpack_public_path__ + "static/img/logo.fcd74b3.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.jpg
// module id = 4Uwr
// module chunks = 1